import React from 'react'
import { Typography } from '@material-ui/core'

export const SingleValue = props => (
  <Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
    {props.children}
  </Typography>
)



// WEBPACK FOOTER //
// ./src/components/SelectAutocomplete/components/SingleValue/index.js